var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 13C25 19.2413 18.0762 25.7412 15.7512 27.7487C15.5347 27.9116 15.271 27.9997 15 27.9997C14.729 27.9997 14.4653 27.9116 14.2488 27.7487C11.9238 25.7412 5 19.2413 5 13C5 10.3478 6.05357 7.8043 7.92893 5.92893C9.8043 4.05357 12.3478 3 15 3C17.6522 3 20.1957 4.05357 22.0711 5.92893C23.9464 7.8043 25 10.3478 25 13Z",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.75C17.0711 16.75 18.75 15.0711 18.75 13C18.75 10.9289 17.0711 9.25 15 9.25C12.9289 9.25 11.25 10.9289 11.25 13C11.25 15.0711 12.9289 16.75 15 16.75Z",
    stroke: "#F3F3F3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.965171b40545cdcb86779aafba48ca02.svg";
export { ForwardRef as ReactComponent };